<template>

    <div class="avatar" :title="name" :style="styles">
        <span class="symbol" :style="initialStyles">
            <span v-if="icon"><i :class="icon" /></span>
            <span v-else>{{ initials | truncate(2, '') }}</span>
        </span>
        <div class="photo" :style="photoStyles"></div>
    </div>

</template>

<style scoped lang="scss">

    .avatar {
        display: grid;
        flex-shrink: 0;
        overflow: hidden;
        .photo {
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border-color: $color-white;
            border-style: solid;
            grid-column-start: 1;
            grid-row-start: 1;
            overflow: hidden;
        }
        .symbol {
            @include font-bold(9px);
            border-color: $color-white;
            border-style: solid;
            color: $color-white;
            display: grid;
            grid-column-start: 1;
            grid-row-start: 1;
            line-height: 0;
            place-items: center;
            text-transform: uppercase;
            user-select: none;
        }
    }

</style>

<script>

import initials from 'initials';

export default {

    props: {
        name: {
            type: String,
        },
        icon: {
            type: String,
        },
        color: {
            type: String,
            default: '#999',
        },
        size: {
            type: Number,
            default: 40,
        },
        radius: {
            type: Number,
            default: 3,
        },
        border: {
            type: Number,
            default: 0,
        },
        url: {
            type: String,
        },
    },

    computed: {

        initials() {
            return this.name ? initials(this.name) : '?';
        },

        styles() {
            return {
                'border-radius': `${this.radius}px`,
            }
        },

        fontSize() {
            if (this.size <= 40) return '10px';
            if (this.size <= 50) return '14px';
            if (this.size <= 100) return '20px';
            return '30px';
        },

        initialStyles() {
            return {
                'background-color': this.color ?? '#999',
                'border-width': `${this.border}px`,
                'border-radius': `${this.radius}px`,
                'font-size': this.fontSize,
                'height': `${this.size}px`,
                'width': `${this.size}px`,
            }
        },

        photoStyles() {
            return {
                'background-image': this.url ? `url('${this.url}')` : '',
                'border-width': `${this.border}px`,
                'border-radius': `${this.radius}px`,
                'height': `${this.size}px`,
                'width': `${this.size}px`,
            }
        },

    },

}

</script>